<h5 class="dialog-title fw-bold">Inserisci nuova delega</h5>
<div class="p-4" mat-dialog-content>
  <form [formGroup]="form">
    <div class="row g-3 mb-3">
      <div class="col-12">
        <label class="form-label required" for="matricolaDelegante">Delegante</label>
        <select formControlName="matricolaDelegante" class="form-select" id="matricolaDelegante">
          <option [ngValue]="null">Seleziona delegante...</option>
          <option *ngFor="let d of data.deleganti" [ngValue]="d.email">
            {{ d.nomeCompleto }} ({{ d.email }})
          </option>
        </select>
        @if (form.get('matricolaDelegante')?.errors?.['required'] && form.get('matricolaDelegante')?.touched) {
        <div class="invalid-feedback">Il delegante è obbligatorio</div>
        }
      </div>
      <div class="col-12">
        <label class="form-label required" for="matricolaDelegato">Delegato</label>
        <select formControlName="matricolaDelegato" class="form-select" id="matricolaDelegato">
          <option [ngValue]="null">Seleziona delegato...</option>
          <option *ngFor="let d of data.delegabili" [ngValue]="d.email">
            {{ d.nomeCompleto }} ({{ d.email }})
          </option>
        </select>
        @if (form.get('matricolaDelegato')?.errors?.['required'] && form.get('matricolaDelegato')?.touched) {
        <div class="invalid-feedback">Il delegato è obbligatorio</div>
        }
      </div>
    </div>
    @if (deleganteUgualeDelegato) {
    <div class="alert alert-warning mb-3">
      Delegante e delegato non possono coincidere.
    </div>
    }
  </form>
</div>
<div mat-dialog-actions class="p-4 d-flex justify-content-end">
  <button
    (click)="reject()"
    type="button"
    class="btn btn-outline-primary me-4"
  >
    Annulla
  </button>
  <button
    (click)="confirm()"
    type="button"
    class="btn btn-primary"
    [disabled]="form.invalid || deleganteUgualeDelegato"
  >
    Conferma
  </button>
</div>
